<template>
  <div class="courselist">
    <div class="banner_container">
      <div class="banner_title">{{ this.$route.query.name }}</div>
      <img
        src="~@/assets/images/listitem/国外影城一瞥- banner (1).png"
        alt=""
        style="width: 100%; height: 100%"
      />
    </div>
    <div class="container_wrap">
      <div class="star_list">
        <template v-if="ItemData.length">
          <div
            class="star_list_item"
            v-for="(item, index) in ItemData"
            :key="index"
            @click="itemClickFun(item)"
          >
            <div class="star_list_item_pic">
              <img src="#" alt="" v-if="item.pics.length == 0" />
              <img :src="item.pics[0].url" alt="" v-else />
            </div>
            <div class="star_list_item_title">{{ item.title }}</div>
            <div class="star_list_item_decs">
              {{ item.desc }}
            </div>
          </div>
        </template>
        <img
          src="~@/assets/images/listitem/course_constuct.png"
          class="list_empty_img_class"
          v-else
        />
      </div>
    </div>
    <DeBounce
      :fetch-fun="getNewsItemlist"
      :pagefetchflag="pagefetchflag"
    ></DeBounce>
  </div>
</template>

<script >
import DeBounce from "@/components/DeBounce";
export default {
  name: "ForeignFilm",
  components: {
    DeBounce,
  },
  data() {
    return {
      ItemData: [{ pics: [{ url: "" }] }],
      pagefetchflag: true,
      listParams: {
        p: 1,
        step: 20,
        cate_id: this.$route.query.id,
      },
    };
  },
  mounted() {
    this.getNewsItemlist();
  },
  updated() {
    var dom = document.getElementsByClassName("star_list_item_decs");
    if (dom) {
      this.handleDescLinelengthFun(2.5, dom);
    }
  },
  methods: {
    //处理文本显示两行半 line 行数/className 文本类名
    handleDescLinelengthFun(line, className) {
      var textLength = className[0]["childNodes"][0].length; //文本长度
      var fontSize = getComputedStyle(className[0], undefined)
        .getPropertyValue("font-size")
        .substr(0, 2); //获取字体大小
      var lineNum = Math.round(className[0].clientWidth / fontSize); //四舍五入,一行有多少字
      if (textLength > lineNum * line) {
        var newText =
          className[0].innerText.substr(0, Math.round(lineNum * line)) + "...";
        className[0].innerText = newText;
      }
    },
    itemClickFun(item) {
      this.$router.push({ name: "CmsSinglePage", query: { id: item.id } });
    },
    //国外影城一瞥
    getNewsItemlist() {
      const that = this;
      that.$api.get(
        "/api/cms/helpList",
        this.listParams,
        (res) => {
          // this.$message.success("发送成功");
          // console.log("resres.....",res)
          // that.ItemData = res.data.list;
          if (this.listParams.p == 1) {
            that.ItemData = res.data.list;
          } else {
            if (res.data.list && res.data.list.length < this.listParams.step) {
              this.pagefetchflag = false;
              // this.$message.success("已加载全部！");
            }
            that.ItemData = that.ItemData.concat(res.data.list);
          }
          if (this.pagefetchflag) {
            this.listParams.p += 1;
          }
        },
        (r) => {
          that.$message.error(r.msg);
        }
      );
    },
  },
};
</script>

<style scoped lang="scss">
.courselist {
  //   height: 1283px;
  background: #f4faff;
}
.banner_container {
  max-height: 318px;
  width: 100%;
  background: #f4faff;
  position: relative;
  //   background: #115ef6;
  overflow: hidden;
  border: none;
  .banner_title {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 1240px;
    font-size: 48px;
    font-family: "Euclid Flex Bold", Arial, "PingFang SC", Verdana,
      "\5FAE\8F6F\96C5\9ED1";
    font-weight: 400;
    color: #ffffff;
    cursor: default;
  }
  img {
    margin-top: -0.5px;
    object-fit: cover;
  }
}
.container_wrap {
  background: #f4faff;
  width: 1240px;
  margin: 0 auto;
  min-height: 1285px;
  padding-bottom: 50px;
}
.star_list {
  width: 100%;
  padding-top: 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  // justify-content: space-evenly;
  .star_list_item {
    // flex:33%;
    display: flex;
    flex-direction: column;
    margin-top: 33px;
    cursor: default;
    width: 380px;
    height: 403px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.06);
    border-radius: 32px;
    overflow: hidden;
    transition: all 0.3s;
    &:hover {
      transform: scale(1.03);
      cursor: pointer;
    }
    &:nth-child(3n + 2) {
      margin-right: 50px;
      margin-left: 50px;
    }
    .star_list_item_pic {
      width: 380px;
      height: 251px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .star_list_item_title {
      max-height: 380px;
      font-size: 22px;
      font-family: "Euclid Flex Bold", Arial, "PingFang SC", Verdana,
        "\5FAE\8F6F\96C5\9ED1";
      font-weight: 500;
      color: #000000;
      line-height: 32px;
      margin: 24px 0 20px 12px;
    }
    .star_list_item_decs {
      width: 350px;
      font-size: 14px;

      font-weight: 400;
      color: #666666;
      line-height: 20px;
      margin-left: 12px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// ForeignFilm.vue?4dbb4d1b